module.exports = __webpack_public_path__ + "img/dresdenerEntwurf.e3b590fa.svg";